'use client';

import React from 'react';
import SearchArea from '@/components/city/search-area';
import RenderTabs from '@/components/RenderTabs';
import IndustrySalary from '@/components/city/tabs/IndustrySalary';
import IndustryTrend from '@/components/city/tabs/IndustryTrend';
import IndustryRatio from '@/components/city/tabs/IndustryRatio';
import SalaryRankRatio from '@/components/city/tabs/SalaryRankRatio';
import WorkDistribution from '@/components/city/tabs/WorkDistribution';
import Summary from '@/components/city/summary';
import NearCity from '@/components/city/tabs/NearCity';
import HotJobOpportunity from '@/components/city/HotJobOpportunity';
import HotSimilarJobTitle, {
  HotSimilarJobTitlesType,
} from '@/components/city/HotSimilarJobTitle';
import RecommendPosts, { PostType } from '@/components/home-page/RecommendPost';
import { CityContextType } from '@/context/city';
import { CityContext } from '@/context/create-context';
import { JobOpportunityType } from '@/components/job-opportunity-panel';
import { CascadeOption } from '@/components/form/inputs/CascadeSelect';
import {
  TAB_INDUSTRY_RATIO,
  TAB_INDUSTRY_SALARY,
  TAB_INDUSTRY_TREND,
  TAB_NEAR_CITY,
  TAB_SALARY_RANK_RATIO,
  TAB_WORK_DISTRIBUTION,
} from '@/constants/city';
import { useBodyClassName, useClintMediaQuery } from '@/utils/hooks';

interface CityProps {
  citiesDetail: CityContextType;
  existCities: CascadeOption[];
  hotJobOpportunities: JobOpportunityType[];
  hotJobTitles: HotSimilarJobTitlesType;
  posts: PostType[];
}

export const TabsContent = [
  {
    key: TAB_NEAR_CITY,
    id: TAB_NEAR_CITY + '-tab',
    node: <NearCity />,
  },
  {
    key: TAB_INDUSTRY_SALARY,
    id: TAB_INDUSTRY_SALARY + '-tab',
    node: <IndustrySalary />,
  },
  {
    key: TAB_INDUSTRY_TREND,
    id: TAB_INDUSTRY_TREND + '-tab',
    node: <IndustryTrend />,
  },
  {
    key: TAB_INDUSTRY_RATIO,
    id: TAB_INDUSTRY_RATIO + '-tab',
    node: <IndustryRatio />,
  },
  {
    key: TAB_SALARY_RANK_RATIO,
    id: TAB_SALARY_RANK_RATIO + '-tab',
    node: <SalaryRankRatio />,
  },
  {
    key: TAB_WORK_DISTRIBUTION,
    id: TAB_WORK_DISTRIBUTION + '-tab',
    node: <WorkDistribution />,
  },
];

const City = (props: CityProps) => {
  const {
    citiesDetail,
    existCities,
    hotJobOpportunities,
    hotJobTitles,
    // posts,
  } = props;
  const isMobile = useClintMediaQuery();

  useBodyClassName(
    '[background:linear-gradient(180deg,rgba(255,255,255,0)_0%,#fff_98.49%),linear-gradient(90deg,rgba(90,183,246,0.2)_0%,rgba(4,45,127,0.2)_100%),#fff]',
  );

  return (
    <CityContext.Provider value={{ ...citiesDetail }}>
      <SearchArea existCities={existCities} />
      <Summary />
      <RenderTabs
        showTip={false}
        content={TabsContent}
        recommendedJobOpportunities={hotJobOpportunities.slice(0, 3)}
        // recommendPost={posts?.[0]}
        marginTop="tablet:mt-0"
      />
      <HotJobOpportunity data={hotJobOpportunities} />
      <HotSimilarJobTitle data={hotJobTitles} />
      {isMobile && (
        <div className="block tablet:hidden">
          <RenderTabs
            content={TabsContent}
            recommendedJobOpportunities={hotJobOpportunities.slice(0, 3)}
            // recommendPost={posts?.[0]}
            showTip={false}
            showLeft={false}
          />
        </div>
      )}
      <RecommendPosts posts={[]} />
    </CityContext.Provider>
  );
};

export default City;
